import { Injectable } from '@angular/core';
import { SysAccount as Account } from './sys.account';
import { SysMenus as Menus } from './sys.menus';
import{SysWxconfig} from './sys.wxconfig';
@Injectable()
export class BaseModal {
  constructor() {

  }
  /**
   * 获取微信配置
   */
  private _wxconfig:SysWxconfig=new SysWxconfig();
  /**
   * 获取菜单列表
   */
  private _submenus: Array<Menus> = new Array<Menus>();
  /**
   * 获取用户信息列表
   */
  private _account: Account = new Account();
  /**
   * 状态栏消息
   */
  private _staticMessage:Array<any> = new Array<any>();
  /**
   * 强制弹出消息
   */
  private _alertMessage:Array<any>=new Array<any>();
  /**
   * 菜单是否显示
   */
  private _isMenusHome = false;
  /**
   * 是否显示菜单
   */
  private _isDisplayMenus:boolean =true;//

  /**
   * 获取列表箱数
   */
  private _gridListCount:number = 0;
  /**
   * 获取列表礼品/样品数量
   */
  private _gridGiftCount:number = 0;
 /**
   * 获取样品数量
   * GridGiftNumber
   */
  private _gridGiftNumber:number = 0;
  /**
   * action
   */
  private _urlAction = undefined;

  /**
   * 选中的菜单
   */
  private _isMenusAction = undefined;

  /**
   * 选中的组织
   */
  private _department = undefined;
  private _gridArrayData:Array<any>=[];
  /**
   * 设置的分钟
   */
  private _minute:number=0;
  /**
   * 设置的秒
   */
  private _second:number=59;
    /**
   *当前答题的页数
   */
  private _pagenumber:number=0;
  /**
   * 是否倒计时启动
   */
  private _interval:boolean=false;
  /**
   * 倒计时获取的时间
   */

  private _time:any="00:00";
  
  private _lock:boolean=false;
  /**
   * 未读消息
   */
  private _unreadMessage:number=0;
/**
 * 计时器
 */
  private _timer:number=0;
  /**
   * 扫码销量
   */
  private _integralCodeDetailList:Array<any> = new Array<any>();
/**
   * boolean值
   */
  private _isCustomer:boolean = false;
    /**
   * 判断是正式版还是测试版本
   */
  private _science:boolean = true;
  /**
   * 获取当前测试版地址
   */
 private _websiteurl:string;
  /**
  * 子菜单
  */
  get subMenus(): Array<Menus> {
    return this._submenus;
  }
  /**
  * 子菜单
  */
  set subMenus(value: Array<Menus>) {
    this._submenus = value;
  }
  /**
   * 判断是否登录
   */
  set account(value: Account) {
       localStorage.setItem("account",JSON.stringify(value));
    this._account = value;
  }
  get account() {
    return this._account;
  }
  get IsMenusHome() {
    return this._isMenusHome;
  }
  set IsMenusHome(value: any) {
    this._isMenusHome = value;
  }
  /**
   * 判断菜单是否显示
   */
  get IsDisplayMenus(){
    return this._isDisplayMenus;
  }
  set IsDisplayMenus(value:any){
    this._isDisplayMenus=value;

  }
  /**
   * url地址
   */
  get UrlAction() {
    return this._urlAction;
  }
  /**
   * url地址链接
   */
  set UrlAction(value: any) {
    this._urlAction = value;
  }

  /**
   * 选中的一级菜单
   */
  get IsMenusAction() {
    return this._isMenusAction;
  }
  /**
   * 选中的一级菜单
   */
  set IsMenusAction(value: any) {
    this._isMenusAction = value;
  }

  /**
   * 选中的组织
   */
  get Department() {
    return this._department;
  }
  /**
   * 选中的组织
   */
  set Department(value: any) {
    this._department= value;
  }
  /**获取列表数据 */
  get GridArrayData():Array<any>{
    return this._gridArrayData;
  }
  /**
   * 获取列表
   */
  set GridArrayData(value:Array<any>){

    this._gridArrayData = value;
  }

  /**
   * 列表总和
   */
  get GridListCount():number{
    return this._gridListCount;
  }
  set GridListCount(value:number){
    this._gridListCount = value;
  }
  /**
   * 赠品总和
   */
  get GridGiftCount():number{
    return this._gridGiftCount;
  }
  set GridGiftCount(value:number){
    this._gridGiftCount=value;
  }
  /**
   * 样品总和
   */
  get GridGiftNumber():number{
    return this._gridGiftNumber;
  }
  set GridGiftNumber(value:number){
    this._gridGiftNumber=value;
  }
/**
 * 获取分钟
 */
  get Minute(){
      return this._minute;
    }
   
  set Minute(value:number){

    this._minute = value;
  }
  /**
   * 获取秒
   */
  get Second(){
    return this._second;
  }
  set Second(value:number){
    this._second = value;
  }
  /**倒计时时间 */
  get timeOut(){
    return this._time;
  }
  set timeOut(value:any){
    this._time = value;
  }
  /**
   * 获取当前第几题
   */
  get PageNumber(){
    return this._pagenumber;
  }
  set PageNumber(value:number){
    this._pagenumber=value;
  }
  /**
   * 倒计时是否启动
   */
  get InterVal(){
    return this._interval;
  }
  set InterVal(value:boolean){
    this._interval=value;
  }
  get StaticMessage(){
    return this._staticMessage;
  }
  set StaticMessage(value:Array<any>){
    this._staticMessage=value;
  }
  get AlertMessage(){
    return this._alertMessage;
  }
  set AlertMessage(value:Array<any>){
    this._alertMessage=value;
  }
  /**
   * 锁，针对实时消息,防止每次请求
   */
  get Lock(){
    return this._lock;
  }
  set Lock(value:boolean){
    this._lock=value;
  }
  /**
   * 计算次数,针对消息强制提醒
   */
  get Timer(){
    return this._timer;
  }
  set Timer(value:number){
    this._timer=value;
  }
    /**
   * 未读消息提醒
   */
  get UnReadMessage(){
    return this._unreadMessage;
  }
  set UnReadMessage(value:number){
    this._unreadMessage=value;
  }
  /**
   * 扫码销量
   */
  get IntegralCodeDetailList(){
    return this._integralCodeDetailList;
  }
  set IntegralCodeDetailList(value:any){
     this._integralCodeDetailList=value;
  }
  /**
   * boolean
   */
  get IsCustomer(){
    return this._isCustomer;
  }
  set IsCustomer(value:any){
     this._isCustomer=value;
  }
    /**
   * 判断是正式版还是测试版本
   */
  get Science(){
    return this._science;
}
set Science(value:any){
  this._science =value;
}
  /**
   * 判断是正式版还是测试版本
   */
get WebsiteUrl(){
    return this._websiteurl;
}
set WebsiteUrl(value:any){
  this._websiteurl =value;
}
  /**
   * 微信配置项
   */
  get WxConfig(){
    return this._wxconfig;
}
/**
 * 微信配置项
 */
set WxConfig(value:any){
  this._wxconfig =value;
}

}